/**
 * titleId 工具函数 - 兼容字符串与数组两种配置模式
 */

const DEFAULT_TITLE_FIELD = 'tenantName';
const DEFAULT_SEPARATOR = '/';

/**
 * 将 titleId 规范化为字段数组
 */
export function normalizeTitleIds(
  titleId: string | string[] | undefined | null
): string[] {
  if (!titleId) {
    return [];
  }
  if (Array.isArray(titleId)) {
    return titleId.filter((id) => id != null && String(id).trim() !== '');
  }
  if (typeof titleId === 'string' && titleId.trim()) {
    return [titleId.trim()];
  }
  return [];
}

/**
 * 获取主标题字段（兼容旧版单字段配置）
 */
export function getPrimaryTitleField(
  titleId: string | string[] | undefined | null,
  defaultField = DEFAULT_TITLE_FIELD
): string {
  const titleIds = normalizeTitleIds(titleId);
  return titleIds[0] || defaultField;
}

/**
 * 根据多个字段拼接节点标题
 */
export function buildNodeTitle(
  record: Record<string, any>,
  titleId: string | string[] | undefined | null,
  separator = DEFAULT_SEPARATOR
): string {
  const titleIds = normalizeTitleIds(titleId);
  if (titleIds.length === 0) {
    return record.title || record.name || record.treeName || '';
  }

  const values = titleIds
    .map((fieldId) => {
      const val = record[fieldId];
      return val != null ? String(val).trim() : '';
    })
    .filter((val) => val !== '');

  if (values.length > 0) {
    return values.join(separator);
  }

  return record.title || record.name || record.treeName || '';
}

/**
 * 递归应用多字段标题到树节点
 */
export function applyMultiFieldTitles(
  nodeList: any[],
  titleId: string | string[] | undefined | null,
  separator = DEFAULT_SEPARATOR
): void {
  const titleIds = normalizeTitleIds(titleId);
  if (titleIds.length <= 1 || !nodeList?.length) {
    return;
  }

  const applyToNode = (node: any) => {
    node.title = buildNodeTitle(node, titleIds, separator);
    if (Array.isArray(node.children) && node.children.length > 0) {
      node.children.forEach(applyToNode);
    }
  };

  nodeList.forEach(applyToNode);
}
